import styled from 'styled-components';
import { texts, statuses } from '../../themes/'

export const HistoryTab = styled.div``;

export const HistoryEvent = styled.div`
  width: 50%;
  float: left;
  paddingRight: 105px;
  position: releative;
  top: 5px;
  padding: 20px;
  box-sizing: border-box;
`;

export const LinkText = styled.span`
  color: #277dd0;
  cursor: pointer;
`;

export const HistoryMap = styled.div`
  width: 50%;
  height: 652px;
  float: right;
  padding: 20px;
  box-sizing: border-box;
`;

export const CopyLinkHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 25px;
`;

export const HistoryList = styled.div `
  padding-left: 4px;
`;

export const PageTitle = styled.h1`
  ${texts.pageTitle},
  display: flex;
  flex: 1;
  padding: 0;
  margin: 0;
  font-size: 30px;
`;

export const StatusLabel = styled.label`
  font-family: 'AvenirNext-DemiBold';
  font-size: 15px;
  color: #bec6d8;
  text-transform: uppercase;
  margin: 0 5px;
`;

export const StatusText = styled.span`
  font-family: 'AvenirNext-DemiBold';
  font-size: 20px;
  color: #f5a623;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const Status = styled.span`
  margin: 0 5px;
`;

export default {
  status: statuses
}
